"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var custom_metrics_1 = require("@clientConstants/custom-metrics");
var default_decimal_places_1 = require("@clientConstants/default-decimal-places");
var context_meta_1 = require("@shared/types/context-meta");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
// @ts-ignore
var string_math_1 = __importDefault(require("string-math"));
(function (module) {
    module.factory('pr.customMetricsService', [
        '$filter',
        'prActiveReport',
        function (
        // @ts-ignore
        $filter, activeReport) {
            var translate = $filter('translate');
            var nan = translate('NOT_APPLICABLE');
            var getNewCustomMetric = function () {
                return {
                    id: generateID(),
                    name: translate('PR.CUSTOM_METRICS.NEW_CUSTOM_METRIC'),
                    equation: '',
                    values: {}
                };
            };
            var copyCustomMetric = function (customMetric) {
                return {
                    id: generateID(),
                    name: customMetric.name + " " + translate('COPY'),
                    equation: customMetric.equation,
                    values: customMetric.values
                };
            };
            var getCustomMetric = function (id) {
                // @ts-ignore
                return lodash_1.default.find(getCustomMetrics(), { id: id });
            };
            // Return a deep clone to prevent outside callers from manipulating the context meta
            var getCustomMetrics = function () {
                return lodash_1.default.cloneDeep(activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CUSTOM_METRICS)) || [];
            };
            var saveCustomMetrics = function (customMetrics) {
                return activeReport.setMetadata(context_meta_1.CONTEXT_META_VARS.CUSTOM_METRICS, customMetrics);
            };
            var generateID = function () {
                var prefix = 'metric-';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var ret = '';
                for (var i = 0; i < 10; i += 1) {
                    ret += possible.charAt(Math.floor(Math.random() * possible.length));
                }
                return prefix + ret;
            };
            var getPipedTextAttributes = function (customMetric) {
                var entries = customMetric.equation.match(custom_metrics_1.CUSTOM_METRIC_REGEX) || [];
                return entries.map(function (entry) {
                    return customMetric.values[entry];
                });
            };
            var resolveEquation = function (customMetric, responses) {
                var equation = customMetric.equation;
                var entries = equation.match(custom_metrics_1.CUSTOM_METRIC_REGEX) || [];
                entries.forEach(function (entry, index) {
                    equation = equation.replace(entry, responses[index].ptAttrs.innerText);
                });
                try {
                    var globalDecimalPlaces = activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.GLOBAL_OPTIONS).decimalPlaces;
                    var decimalPlaces = globalDecimalPlaces !== null && globalDecimalPlaces !== void 0 ? globalDecimalPlaces : default_decimal_places_1.DEFAULT_DECIMAL_PLACES;
                    var computedNumber = string_math_1.default(equation);
                    return $filter('number')(computedNumber, decimalPlaces);
                }
                catch (e) {
                    console.error('error computing custom metric equation', e);
                    return nan;
                }
            };
            return {
                getNewCustomMetric: getNewCustomMetric,
                saveCustomMetrics: saveCustomMetrics,
                getCustomMetric: getCustomMetric,
                getCustomMetrics: getCustomMetrics,
                copyCustomMetric: copyCustomMetric,
                resolveEquation: resolveEquation,
                getPipedTextAttributes: getPipedTextAttributes
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
